import { PillOffIcon } from './PillOffIcon';

/**
 * author: Contributors
 * id 70E290E6-75B8-4976-8206-C066C02C5344
 * name pill-off
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pill-off.svg
 * tags
 * - Medical / Hospital 
 */
export const CapsuleOffIcon = PillOffIcon;
export default CapsuleOffIcon